module.exports = __webpack_public_path__ + "img/floor_EG1.d7c3146d.svg";